"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "missaglia": {
    "0c73a629": [{
      "hkey": "cb3034c0",
      "slug": "missaglia",
      "name": "Missaglia",
      "primary": true,
      "skipSearch": false
    }],
    "bariano": [{
      "hkey": "cb3034c0",
      "slug": "missaglia",
      "name": "Missaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e08c213c": [{
      "hkey": "dd4c4010",
      "slug": "missagliola-contra",
      "name": "Missagliola-Contra",
      "primary": true,
      "skipSearch": false
    }],
    "contra": [{
      "hkey": "dd4c4010",
      "slug": "missagliola-contra",
      "name": "Missagliola-Contra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "missaglia"
    }],
    "081561dc": [{
      "hkey": "dd4c4010",
      "slug": "missagliola-contra",
      "name": "Missagliola-Contra",
      "primary": true,
      "skipSearch": false
    }],
    "missagliola": [{
      "hkey": "dd4c4010",
      "slug": "missagliola-contra",
      "name": "Missagliola-Contra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a871347e": [{
      "hkey": "a37aec39",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "molinata": [{
      "hkey": "a37aec39",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "missaglia"
    }]
  }
};
exports["default"] = _default;